export const EditorVI = {
    dg_editor: {
        heading: {
          image: "Ảnh",
          video: "Video"
        },
        placeholder: {
            common: "Bắt đầu gõ văn bản",
            title: "Nhập title"
        },
        message: {
            error: {
                url: "Tệp không tồn tại"
            }
        },
        label: {
            title: "Tiêu đề"
        },
        btn: {
            update: "Cập nhật"
        }
    }
}